// K2E: sin temas propios ni restricciones (catálogo completo, por defecto «clínico»).
import type { MarcaTema } from '../types';

export const temaMarca: MarcaTema = {};
